import { useCallback, useEffect, useRef, useState } from "react";

export default function useSingleFlight() {
  const inFlightRef = useRef(false);
  const mountedRef = useRef(true);
  const [isRunning, setIsRunning] = useState(false);

  useEffect(() => {
    return () => {
      mountedRef.current = false;
    };
  }, []);

  const run = useCallback(async (task) => {
    if (inFlightRef.current) return null;
    inFlightRef.current = true;
    if (mountedRef.current) {
      setIsRunning(true);
    }
    try {
      return await task();
    } finally {
      inFlightRef.current = false;
      if (mountedRef.current) {
        setIsRunning(false);
      }
    }
  }, []);

  return { run, isRunning };
}
